import TitleDashboard from '@components/general/Titles/TitleDashboard'
import React from 'react'
import { Accordion, Col, Container, Image, Row } from 'react-bootstrap'

const DashboardDocumentacionFrontend = () => {
    return (
        <Container fluid>
            <Row className="mb-4">
                <Col>
                    <h2>Estructura del proyecto</h2>
                    <small>Diagramas con la estructura básica de la plataforma web y móvil.</small>
                    <Row className="mt-3">
                        <Col>
                            <Accordion>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Estructura base de la plataforma</Accordion.Header>
                                    <Accordion.Body className="text-center">
                                        <Image fluid width={"80%"} src={"https://globalclickmexico.com/img/documentacion/estructura_plataforma.png"} />
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>Estructura base del frontend (plataforma web)</Accordion.Header>
                                    <Accordion.Body className="text-center">
                                        <Image fluid width={"80%"} src={"https://globalclickmexico.com/img/documentacion/estructura_frontend.png"} />
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>Estructura base del frontend (plataforma móvil)</Accordion.Header>
                                    <Accordion.Body className="text-center">
                                        <Image fluid width={"80%"} src={"https://globalclickmexico.com/img/documentacion/estructura_frontend_app_movil.png"} />
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Row className='mb-4'>
                <Col><h2>Dar de alta la versión de desarrollo en tu equipo.</h2>
                    <small>Instrucciones para clonar el proyecto y comenzar a desarrollar en el proyecto por primera vez.</small>
                    <Row className="mt-3">
                        <Col>
                            <Accordion>
                                <Accordion.Item eventKey="8">
                                    <Accordion.Header>Clonando el repo para comenzar con el desarrollo</Accordion.Header>
                                    <Accordion.Body className="text-start">
                                        <TitleDashboard title={"Comenzando con el desarrollo"} />
                                        <p>Bienvenido al desarrollo de la plataforma, a continuación te guiaré para que puedas comenzar a clonar el repositorio para editar o mejorar el proyecto, primero comenzaremos por la versión web y finalizaremos con la versión móvil.</p>

                                        <p>Antes de comenzar a clonar el repositorio, asegurate de tener instalado lo siguiente: </p>

                                        <ul>
                                            <li>node js (v.14.17.6 recomendada para comenzaar, una vez instalado y levantada la plataforma, no hay problema en usaar una version más reciente)</li>
                                            <li>git</li>
                                            <li>mysql server 8.0</li>
                                            <li>mysql workbench v.8.0</li>
                                            <li>Herramienta para la gestión de repositorios Fork</li>
                                            <li>Postman (Para realizar pruebas a la api en desarrollo y más.)</li>
                                            <li>Un editor de codigo (visual studio code es el más recomendado).</li>
                                            <li>Archivo package.lock.json (Importante para evitar problemas de versiones)</li>


                                        </ul>

                                        <p>Una vez que tengas acceso al repositorio de la empresa <a href='https://github.com/globalclickmexico/plataforma' target='_blank'>https://github.com/globalclickmexico/plataforma</a> por favor sigue las instrucciones para poder clonar y levntar el proyecto para desarrollo.</p>

                                        <p className="text-danger"><b>Notas importantes: </b></p>
                                        <ul>
                                            <li>Antes de ejecutar el proyecto y comenzar a usarlo hay que tener dada de alta la base de datos, la información se encuentra dentro del proyecto en la carpeta <b>dev-tools</b></li>
                                            <li>Ejecuta primero el archivo que contiene las tablas y luego el de la información, en caso de algún error, corregirlo y comenzar de nuevo.</li>
                                            <li>Al configurar el server de mysql asegúrate de tener como usuario y contraseña root para hacer la conexión correctamente.</li>
                                        </ul>
                                    </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="9">
                                    <Accordion.Header>Después de comenzar el desarrollo</Accordion.Header>
                                    <Accordion.Body className="text-start">
                                        <TitleDashboard title={"Una vez dado de alta el proyecto..."} />
                                        <p>Una vez dado de alta el proyecto para desarrollo es necesario que conozcas el proceso de actualización.</p>
                                        <p>Al realizar cambios en el proyecto, antes de enviar los cambios a producción es necesario probarlos en el ambiente de pruebas QA para evitar tirar la versión de producción en caso de algún error por los caambios.</p>
                                        <p>Para subir los camnbios es necesario seguir estos pasos: </p>
                                        <ul>
                                            <li>Una vez que hayas subido los cambios al repo dev, necesitas cambiar al repositorio de qa ejecutando el siguiente comando en tu consola: 

                                                <p>
                                                    <code>switch qa-prod</code>
                                                </p>
                                            </li>
                                            <li>Para asegurarse de estar en el repo correcto puedes ejecutar <code>git branch</code></li>
                                            <li>Una vez en la rama correcta, realiza un merge con la rama dev para juntar los cambios realizados <code>git merge dev</code></li>
                                            <li>Hecho el merge, ejecuta el comando <code>npm run compile-qa-prod para hacer una build del proyecto.</code></li>
                                            <li>Al finalizar el build y ver que en consola finalizó el proceso de compilación realiza el commit dentro de Fork con algúna de las etiquetas como <b>chore:, fix:</b>, estas etiquetas las puedes ver a continuación para poder ver cual se adapta a tu commit.</li>

                                            <Image className='my-5' fluid width={"80%"} src={require("@assets/images/git-etiquetas.png")} />

                                            <li>Hecho el commit y subido al repo pasaremos a obtener los cambios en el servicio dentro del server de qa o prod dependiendo de la versión que se esté actualizando.</li>

                                            <Image className='my-5' fluid width={"70%"} src={require("./src/solarPanel.png")} />

                                            <li>Solicita a tu gerente de departmento el archivo de las sesiones para acceder a los servidores de la plataforma y demás servicios. Deberás descargar el programa Solar-PuTTY para importar ese archivo de sesiones, ingresar la contraseña y seleccionar el serrvidor deseado, para actualizaciones de la plataforma web se usa el servidor llamado <b>VPS 2 - clickplus</b></li>
                                            
                                            <li>Iniciada la sesión en el servidor puedes ejecutar el comando <code>ls</code> para ver los archivos y directorios dentro de esa carpeta, desplazate a la carpeta del proyecto (En este caso  la carpeta qa_plataforma/app) usando el comando <code>cd qa_plataforma/app</code></li>

                                            <li>Dentro de esta ruta obtendremos los cambios subidos anteriormente al repositorio de la plataforma, usa el comando <code>git pull origin NOMBRE_DE_LA_RAMA y presiona enter para recuperar los cambios.</code></li>

                                            <li>Finalmente será necesario reiniciar el servicio <b>Forever js</b> encargado de mantener los servicios de la plataforma para qa y producción. Utiliza el comando <code>forever list</code> para listar los servicios disponibles en el servidor: </li>

                                            <Image className='my-5' fluid width={"70%"} src={require("./src/foreverList.png")} />

                                            <li>Para reiniciar el servicio deseado da doble clic sobre el id ubicado a la izquierda del path en color morado y usa el comando <code>forever restart ID_SERVICIO</code> para reinciar el servicio. Si tienes alguna duda acude con el gerente de área actual.</li>

                                            <Image className='my-5' fluid width={"70%"} src={require("./src/foreverRestart.png")} />

                                        </ul>

                                        <p>Con esto queda realizada la actualización de la plataforma, puedes ejecutar <code>forever list</code> para asegurarse de que todo cambio se realizó exitosamente.</p>

                                        <p>Para conocer el proceso de actualización para la plataforma móvil accede al apartado de documentación al final de está página.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Row className="mb-4">
                <Col>
                    <h2>Flujo de información</h2>
                    <small>Proceso por el que pasa la información del usuario desde que se dá de alta en SAI hasta que se registra en plataforma.</small>
                    <Row className="mt-3">
                        <Col>
                            <Accordion>
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>Flujo de información Click+ (web)</Accordion.Header>
                                    <Accordion.Body className="text-center">
                                        <Image fluid width={"80%"} src={"https://globalclickmexico.com/img/documentacion/flujo_informacion_web.png"} />
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header>Flujo de información Click+ (móvil)</Accordion.Header>
                                    <Accordion.Body className="text-center">
                                        <Image fluid width={"65%"} src={"https://globalclickmexico.com/img/documentacion/flujo_informacion_movil.png"} />
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Row className='mb-4'>
                <Col>
                    <h2>Base de datos Click+</h2>
                    <small>Diagrama UML al <b>29/01/25</b> de la base de datos de la plataforma.</small>
                    <Row className="mt-3">
                        <Col>
                            <Accordion>
                                <Accordion.Item eventKey="5">
                                    <Accordion.Header>Diagrama UML</Accordion.Header>
                                    <Accordion.Body className="text-center">
                                        <small>Puedes encontrar el archivo dentro del proyecto para visualizarlo mejor</small>
                                        <Image fluid width={"100%"} src={require("@assets/images/modelo_relacional_plataforma.png")} />
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Row className='mb-4'>
                <Col>
                    <h2>Otras aplicaciones de la familia Global Click</h2>
                    <small>Diagramas e información de otros aplicativos de Global Click</small>
                    <Row className="mt-3">
                        <h4>Aplicativos</h4>
                        <Col>
                            <Accordion>
                                <Accordion.Item eventKey="5">
                                    <Accordion.Header>Sim</Accordion.Header>
                                    <Accordion.Body className="text-center">
                                        <p>Sistema para la gestión de las llamadas del departmento de relaciones públicas.</p>
                                        <p><a href='https://sim.globalclickmexico.com' target='_blank' rel='noreferrer'>Accede al aplicativo</a></p>
                                        <Image fluid width={"80%"} src={require("@assets/images/loginSim.png")} />
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="10">
                                    <Accordion.Header>Buscador de usuarios</Accordion.Header>
                                    <Accordion.Body className="text-center">
                                        <p>Sistema de busqueda de usuarios usando la api de google.</p>
                                        <p><a href='https://buscador.globalclickmexico.com/' target='_blank' rel='noreferrer'>Accede al aplicativo</a></p>
                                        <Image fluid width={"80%"} src={require("./src/buscador.png")} />
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <h4>Documentación</h4>
                        <Col>
                            <Accordion>
                                <Accordion.Item eventKey="5">
                                    <Accordion.Header>Diagrama UML de la base de datos del aplicativo SIM</Accordion.Header>
                                    <Accordion.Body className="text-center">
                                        <Image fluid width={"80%"} src={require("@assets/images/modelo_relacional_sim.png")} />
                                    </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="6">
                                    <Accordion.Header>Procesos para actualizar la app móvil Click+</Accordion.Header>
                                    <Accordion.Body className="text-center">
                                        <div className="ratio ratio-16x9 visor-curso">
                                            <iframe
                                                // onLoad={onLoad}
                                                allow="autoplay; encrypted-media"
                                                loading="lazy"
                                                title="Lección actual"
                                                className="embed-responsive-item"
                                                src={'https://globalclicklatam.com/documentacion-app-movil/Procesos_actualizacion_app_movil.pdf'}
                                            ></iframe>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="7">
                                    <Accordion.Header>Integración de Kueski Pay en Click+</Accordion.Header>
                                    <Accordion.Body className="text-start">
                                        <p>La integración de Kueski Pay a Click+ nos permite mejorar las opciones de pago para los clientes, desde la compra de nuevas licencias (Lectura Inteligente, Click+) hasta pagos de renovaciones y liquidar pagos pendientes para licencias Click+.</p>
                                        <p>Aquí encontrarás la documentación completa de la integración para poder atender la integración o mejorarala si es necesario.</p>

                                        <p><a href="https://kueski.atlassian.net/wiki/spaces/MER/pages/1901199863/API+Integration" target='_blank' rel="noreferrer">Documentación</a></p>

                                        <p>En el link se encuentran todos los pasos que se requieren para un escenario completo, se resume en dos pasos:</p>
                                        <ul>
                                            <li>Creación de pago: Donde se requiere que se incluyan al menos los siguientes parámetros / arrays</li>
                                            <ul>
                                                <li>order_id</li>
                                                <li>description</li>
                                                <li>amount</li>
                                                <li>items</li>
                                                <li>shipping - no aplica en productos virtuales</li>
                                                <li>callbacks</li>
                                            </ul>
                                            <li>Merchant's response:  En este paso Kueski envía una notificación a una URL Listener que nosotros definimos (Webhook), en donde incluyen el estatus final del Loan, el proceso finaliza una vez que nosotros recibimos con éxito su notificación y respondemos con la confirmación de acuerdo a los siguientes cuatro escenarios:</li>

                                            <Image fluid width={"40%"} src={require("@assets/images/Kueski/merchantsResponse.png")} />
                                            <li>Para cada request se requiere un tipo de autenticación: </li>
                                            <ul>
                                                <li>Plain. Se utiliza para la creación del pago</li>
                                                <li>JWT. Se utiliza para la conciliación, que corresponde al paso Merchant response en la documentación. </li>
                                            </ul>

                                        </ul>

                                        <Image fluid width={"60%"} src={require("@assets/images/Kueski/integracionKueski.png")} />
                                    </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="8">
                                    <Accordion.Header>Foro de lectura para UVEG</Accordion.Header>
                                    <Accordion.Body className="text-start">
                                       <p>A continuación se muestra el flujo de información para hacer uso del foro de lectura, este es el proceso que se sigue desde que el asesor se da de alta hasta que los usuarios que ingrese al foro ya completan su curso y se hace el registro de su avance en Click+</p>

                                        <Image fluid width={"90%"} src={require("@assets/images/foroLectura/DocumentacionForoLectura.png")} />
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    )
}

export default DashboardDocumentacionFrontend